(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-scroll-video"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.tn-scroll-video');
    if (!section) return;

    // Vorherige Section (Hero) per z-index hochheben, damit das überlappende
    // Scroll-Video DAHINTER sitzt und sich der Hero beim Scrollen davor
    // erst aus dem Viewport schiebt. Ersetzt das nicht universell verfügbare
    // CSS :has() Pattern.
    const sectionWrapper = section.closest('.shopify-section');
    if (sectionWrapper) {
      const prevSection = sectionWrapper.previousElementSibling;
      if (prevSection && prevSection.classList && prevSection.classList.contains('shopify-section')) {
        prevSection.style.position = 'relative';
        prevSection.style.zIndex = '5';
      }
    }

    const video = section.querySelector('.tn-scroll-video__video');
    const track = section.querySelector('.tn-scroll-video__track');
    if (!video || !track) return;

    const scrubEnabled = section.dataset.scrub === 'true';

    // Scrub aus: einfacher Loop, sonst Scroll-Scrub auf allen Devices
    if (!scrubEnabled) {
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      const tryPlay = () => video.play().catch(() => {});
      tryPlay();
      video.addEventListener('canplay', tryPlay, { once: true });
      return;
    }

    // Scroll-Scrub (Desktop + Mobile)
    // Voraussetzung für flüssiges iOS: Video mit allen Frames als Keyframes encoden
    video.pause();
    video.removeAttribute('loop');
    video.muted = true;

    let videoReady = false;
    let lastTime = -1;
    let rafId = null;

    video.addEventListener('loadedmetadata', function () {
      videoReady = true;
      updateVideo();
    });

    function updateVideo() {
      if (!videoReady) return;
      const rect = track.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollable = track.offsetHeight - viewportHeight;
      if (scrollable <= 0) return;

      // Animation endet kurz bevor die nächste Section vollständig
      // den Viewport überdeckt. Effekt: erst Stillstand der Animation,
      // dann (innerhalb von scrub-finish-offset vh) schiebt sich die
      // nächste Section komplett darüber.
      const scrubFinishOffsetVh = parseFloat(section.dataset.scrubFinishOffset) || 0;
      const scrubFinishOffsetPx = (scrubFinishOffsetVh / 100) * viewportHeight;
      const scrubScrollable = Math.max(1, scrollable - scrubFinishOffsetPx);

      const scrolled = -rect.top;
      const progress = Math.max(0, Math.min(1, scrolled / scrubScrollable));
      const targetTime = progress * (video.duration || 1);

      if (Math.abs(targetTime - lastTime) > 0.015) {
        try {
          video.currentTime = targetTime;
          lastTime = targetTime;
        } catch (e) {
          /* Browser refused — silently ignore */
        }
      }
    }

    function onScroll() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(function () {
        updateVideo();
        rafId = null;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateVideo);

    if (video.readyState >= 1) {
      videoReady = true;
      updateVideo();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky-cta"]) return;
  try {
    
  (function () {
    const sticky = document.querySelector('.tn-sticky-cta');
    if (!sticky) return;

    const heroSelector = sticky.getAttribute('data-hero-selector') || '.tn-lp-hero';
    const configSelector = sticky.getAttribute('data-configurator-selector') || '#konfigurator';

    const hero = document.querySelector(heroSelector);
    const configurator = document.querySelector(configSelector);

    let heroInView = !!hero;
    let configInView = false;

    function update() {
      const shouldShow = !heroInView && !configInView;
      if (shouldShow) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tn-has-sticky-cta');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tn-has-sticky-cta');
      }
    }

    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        heroInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' }).observe(hero);
    } else {
      heroInView = false;
    }

    if (configurator && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        configInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0.05 }).observe(configurator);
    }

    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
